var pym = require("./lib/pym");
require("./lib/webfonts");

var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min")
};

var { COLORS, classify } = require("./lib/helpers");

// Global vars
var pymChild = null;
var renderDotChart = require("./renderDotChart");

var dataCols = [];
// var dataColsExcluded = [ 'County Name', 'fips', 'region' ];
var dataColsExcluded = [ 'County Name', 'fips', 'region', '2010 (Senate)', '2016 (Senate)', '2022 (Senate)', '2012_diff', '2012_diff_raw' ];

// Initialize the graphic.
var onWindowLoaded = function() {
  dataCols = Object.keys(window.DATA[0]).filter(d => !dataColsExcluded.includes(d));

  render(window.DATA);
  window.addEventListener("resize", () => render(window.DATA));

  pym.then(child => {
    pymChild = child;
    pymChild.sendHeight();
  });
};

// Render the graphic(s). Called by pym with the container width.
var render = function(data) {
  // Render the chart!
  var container = "#dot-chart";
  var element = document.querySelector(container);
  var width = element.offsetWidth;

  dataCols.forEach(function(election, i) {
    var thisContainer = d3.select(container).append("div")
      .attr("class", `chart e-${ classify(election) }`);

    var showAxis = (i == 0) ? true : false;

    renderDotChart({
      container: `.chart.e-${ classify(election) }`,
      width,
      data,
      labelColumn: "label",
      valueColumn: election,
      xMin: 0,
      xMax: 100,
      showAxis
    }); 
  });

  // document.querySelector(".chart.e-2018-brown circle.mahoning").dispatchEvent("mouseover");
  d3.select(".chart.e-2006-brown circle.mahoning").dispatch("mouseover");

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);